<script setup>
import { Bike, Check, ArrowRight } from 'lucide-vue-next'
import MandaditosFlow from './MandaditosFlow.vue'

const checks = [
  'Recoger tus paquetes.',
  'Pagar tus servicios básicos.',
  'Comprar lo que te faltó en el súper o la farmacia.'
]
</script>

<template>
  <section id="mandaditos" class="relative scroll-mt-24 overflow-hidden bg-[#f0611e] py-20 text-[#0a1120] md:py-28">
    <div class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_18%_12%,#ff9a5c_0%,transparent_46%)] opacity-80"></div>
    <div class="pointer-events-none absolute -right-40 top-10 h-[30rem] w-[30rem] rounded-full bg-[#ffb38a]/30 blur-[120px]"></div>
    <div class="pointer-events-none absolute -bottom-40 -left-24 h-[24rem] w-[24rem] rounded-full bg-[#0a1120]/10 blur-[100px]"></div>

    <div class="container relative z-10 mx-auto px-6 lg:px-12">
      <div class="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">

        <!-- Copy -->
        <div v-reveal class="lg:col-span-7">

          <h2 class="mt-5 text-balance text-3xl font-black leading-[1.05] tracking-[-0.03em] sm:text-4xl md:text-5xl">
            ¿No tienes tiempo?
            <span class="block">Nosotros vamos por ti.</span>
          </h2>

          <p class="mt-5 max-w-2xl text-base font-medium leading-relaxed sm:text-lg">
            ¿Olvidaste las llaves? ¿Necesitas pagar un recibo? ¿Antojo de la pulpería que no está en las apps?
            Escribe lo que necesitas, dinos dónde buscarlo y te lo llevamos.
          </p>

          <p class="mt-4 max-w-2xl text-sm font-black">
            Sin menús cerrados: tú pones las reglas y nosotros ponemos las llantas.
          </p>

          <div class="mt-8 border-t border-[#0a1120]/20 pt-6">
            <p class="text-lg font-black sm:text-xl">Tu tiempo vale más que hacer fila en el tráfico.</p>

            <ul class="mt-4 grid gap-3 sm:grid-cols-3">
              <li v-for="item in checks" :key="item" class="flex items-start gap-2 text-sm font-bold leading-snug">
                <Check :size="16" class="mt-0.5 shrink-0" />
                {{ item }}
              </li>
            </ul>
          </div>

          <a
            href="#app-usuarios"
            class="group mt-8 inline-flex items-center justify-center gap-2 rounded-xl bg-[#0a1120] px-6 py-3.5 text-sm font-bold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#1c2b42]"
          >
            Cotiza tu mandadito en la app
            <ArrowRight :size="16" class="transition-transform group-hover:translate-x-1" />
          </a>

          <p class="mt-3 text-xs font-semibold">
            Tú dinos qué necesitas. Tarifas claras, justas y sin sorpresas al llegar.
          </p>
        </div>

        <!-- Flujo animado de la app -->
        <div v-reveal="{ delay: 120 }" class="flex justify-center lg:col-span-5">
          <MandaditosFlow />
        </div>
      </div>
    </div>
  </section>
</template>
